interface Props {
  messages?: string[];
}

export default function FormBaseError({ messages }: Props) {
  if (!messages?.length) return null;

  return (
    <div role="alert" className="rounded-xl border border-red-100 bg-red-50/80 p-4">
      <p className="text-sm text-red-700">{messages[0]}</p>
    </div>
  );
}
